const obj = () => {
  var urlParam = {}
  // 获取参数
  const url = window.location.href
  console.log(url)
  try {
    const dz_url = url.split('#')[1]
    const cs = dz_url.split('?')[1]
    const cs_arr = cs.split('&')
    console.log('输出参数长度' + cs_arr.length)
    for (let i = 0; i < cs_arr.length; i++) {
      // if (cs_arr[i].split('=')[0] === 'i') {
      //   this.codeMsg = cs_arr[i].split('=')[1]
      // }
      urlParam[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    }
    // eslint-disable-next-line no-empty
  } catch {
    console.log('无参数')
  }
  return urlParam
}

export var urlParam = obj()
